import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const endpoint = "/api";

export const getInformeAvancePoa = async () => {
  const { data } = await axios.get(
    `${baseUrl}${endpoint}/poa_informe_avance`
  );
  return data;
};

export const getInformeReporteProducto = async () => {
  const { data } = await axios.get(
    `${baseUrl}${endpoint}/poa_informe_reporte_producto`
  );
  return data;
};


const poaService = {
  getInformeAvancePoa,
  getInformeReporteProducto,
};

export default poaService;